module.exports = __webpack_public_path__ + "img/Q5.155201f1.jpg";